export default "__VITE_ASSET__904a3bda__"